import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { validateFormData } from "../../../../utils/validation";
import { errorMsg, successMsg } from "../../../../utils/customFn";
import useApiRequest from "../../../../hook/useApiRequest";
import Joi from "joi";
import { API_ENDPOINTS } from "../../../../constants/endPoints";
import { useDispatch } from "react-redux";
import { setProfileData } from "../../../../redux/user/slice/userAuthSlice";

const useAddCustomerUtils = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, fetchData } = useApiRequest();
  const languageId = localStorage.getItem("language_id") || "1";
  const [formErrors, setFormErrors] = useState({});
  const [formData, setFormData] = useState({
    name: "",
    phone_number: "",
    city: "",
    dob: "",
    email: "",
    gender: "",
    profile_picture: "",
    driving_license: "",
    vehicle_registration: "",
    live_photo: "",
    car_photo: "",
    customer_type: "",
    transportation_mode: "",
    is_verified_driver: "",
    status: "",
    driver_status: "",
    verification_status: "",
  });

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const fetchCustomerData = async () => {
    const response = await fetchData(
      `${API_ENDPOINTS?.get_customers}/${id}`,
      navigate
    );

    if (response) {
      console.log(response);
      setFormData((prev) => ({
        ...response,
        transportation_mode: response?.getService?.service_descriptions?.title,
        is_verified_driver: response?.is_verified_driver,
        driver_status: response?.driver_status,
        city: response?.city,
      }));
    }
  };

  useEffect(() => {
    fetchCustomerData();
  }, [id]);

  const fetchProfileData = async () => {
    const response = await fetchData(`${API_ENDPOINTS?.get_profile}`, navigate);
    if (response) {
      dispatch(setProfileData(response));
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();
    try {
      const validationSchema = Joi.object({}).options({
        abortEarly: false,
        allowUnknown: true,
      });

      const { status, errors } = await validateFormData(
        formData,
        validationSchema
      );

      setFormErrors(errors);
      if (!status) return;

      const updatedFormData = {
        is_verified_driver: formData.verification_status == "Verified" ? 1 : 0,
        name: formData.name.trim(),
        profile_picture: formData.profile_picture,
        status: formData.status,
        driver_status: formData.driver_status,
        city: formData.city,
        gender: formData.gender,
        email: formData.email,
        verification_status: formData.verification_status,
      };

      const url = id ? `${API_ENDPOINTS.get_customers}/${id}` : "";
      const response = await fetchData(url, navigate, "PATCH", updatedFormData);

      if (response) {
        if (id) {
          successMsg("Customer has been successfully updated.");

          fetchProfileData();
        }

        if (window.history.length > 1) {
          navigate(-1);
        } else {
          navigate("/main-dashboard");
        }
      }
    } catch (err) {
      errorMsg("An error occurred during submission.");
      console.error("Error during form submission:", err);
    } finally {
    }
  };

  return {
    formData,
    loading,
    fetchData,
    handleFormChange,
    submitForm,
    formErrors,
    setFormData,
    navigate
  };
};

export default useAddCustomerUtils;
